/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisplayMdEntry } from './displayMdEntry';

export interface DisplayMdSnapshot {
  pairSettingId?: number;
  marketEvent?: boolean;
  bids?: Array<DisplayMdEntry>;
  asks?: Array<DisplayMdEntry>;
}
